<template>
  <div class="userIndex">
    <div class="left">
      <div class="titBig">账号中心</div>
      <p
      class="fontcursor"
        @click="link('/user/account/infoIndex/info', 1)"
        :class="{ active_: currentIndex == 1 }"
      >
        基本信息
      </p>
    </div>
    <div class="right">
      <Breadcrumb class="bread">
        <BreadcrumbItem
          v-for="(item, index) in levelList"
          v-if="item.meta.title"
          :key="item.path"
        >
          <span v-if="index == levelList.length - 1">{{
            item.meta.title
          }}</span>
          <router-link v-else :to="item.redirect || item.path">{{
            item.meta.title
          }}</router-link>
        </BreadcrumbItem>
      </Breadcrumb>
      <div class="mainShow">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/user";

export default {
  name: "serIndex",
  components: {},
  data() {
    return {
      currentIndex: 1,
      levelList: [],
      isManager: false,
      showTip: false, //操作提示
      userRole: 0,
      flagAuth: 0,
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
    this.getUserInfo();
  },
  mounted() {
    this.userRole = _GLOBAL.isCertified(); //判断是否认证
    // this.userRole = true; //判断是否认证
  },
  methods: {
    // 获取用户信息，判断是否认证
    getUserInfo() {
      getUserInfo().then((res) => {
        //账号权限
        console.log("用户认证信息", res.data.data.isCertified);
        this.flagAuth = res.data.data.isCertified;
      });
    },
    link(path, num) {
      this.currentIndex = num;
      if (num == 1) {
        this.$router.push({ path: path });
      }
      window.sessionStorage.setItem("currentActive", num);
      this.getBreadcrumb();
    },
    // 获取路由
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.name);
      this.levelList = matched;
    },
  },
  computed: {
    bread() {
      let self = this;
      let navItem = self.$route.meta;
      return navItem.title;
    },
  },
};
</script>

<style lang="scss" scoped>
.userIndex {
  display: flex;
  width: 100%;
  height: 100%;
  .left {
    width: 190px;
    height: 100%;
    background: #ffffff;
    color: #67799c;
    font-size: 14px;
    .titBig {
      width: 142px;
      margin: 0 auto;
      border-bottom: 1px solid #ebedf0;
      padding: 18px 0;
      color: #2f4061;
      font-size: 18px;
      font-weight: bold;
    }
    > p {
      box-sizing: border-box;
      width: 100%;
      height: 38px;
      line-height: 38px;
      padding: 0 24px;
    }
    > p:nth-of-type(1) {
      margin-top: 20px;
    }
    .active_ {
      color: #3c8aff;
      background: rgba(60, 138, 255, 0.05);
    }
  }
  .right {
    width: calc(100% - 190px);
    height: 100%;
    padding: 0px 24px;
    .bread {
      // font-size: 20px;
      color: #2f4061;
      margin: 24px 0;
      // font-weight: bold;
    }
    .mainShow {
      height: calc(100% - 78px);
    }
  }
}
</style>
